import React from 'react';
import { Link } from 'react-router-dom';
import { Constants } from '@pwc/pwc-deals-web-common';
import { useTranslation } from 'react-i18next';

const TermsConditionsLinks = () => {
  const { t } = useTranslation();
  return (
    <div className="terms-and-conditions-links">
      {Constants.TERMS_AND_CONDITIONS_LINKS.map((link) => (
        <Link
          className="footer-link"
          to={`/policies/${link.key}`}
          key={link.key}
        >
          {t(link.key)}
        </Link>
      ))}
    </div>
  );
};

export default TermsConditionsLinks;
